<sb-modal-template [templateId]="templateId">
  <div modal-header>
    <h5 class="modal-title">{{ options.title }} </h5>
  </div>
  <div modal-body>
    <p>{{'lang.requirementBookingAssignment.excludeNotAssigned' | translate}}</p>
    <div class="form-check form-switch ml-3">
      <input type="checkbox" role="switch" class="form-check-input" [id]='"customSwitchExcludeNotAssigned"'
             [(ngModel)]="initial.excludeNotAssigned">
      <label class="form-check-label"
             [for]='"customSwitchExcludeNotAssigned"'></label> {{'lang.requirementBookingAssignment.excludeNotAssigned' | translate}}
    </div>
    <ng-container *ngIf="bookingService.countFilledBookings(bookings) > 0">
      <p>{{bookingService.countFilledBookings(bookings)}} {{'lang.requirementBookingAssignment.assignedBookingsFound' | translate}}</p>
      <div class="form-check form-switch ml-3">
        <input type="checkbox" role="switch" class="form-check-input" [id]='"customSwitchOverrideAssigned"'
               [(ngModel)]="initial.overrideAssigned">
        <label class="form-check-label"
               [for]='"customSwitchOverrideAssigned"'></label> {{'lang.requirementBookingAssignment.overrideAssignedbookings' | translate}}
      </div>
    </ng-container>
    <ng-container *ngIf="bookingService.countExcludedBookings(bookings) > 0">
      <p>{{bookingService.countExcludedBookings(bookings)}} {{'lang.requirementBookingAssignment.excludedBookingsFound' | translate}}</p>
      <div class="form-check form-switch">
        <input type="checkbox" role="switch" class="form-check-input" [id]='"customSwitchFillAndOverride"'
               [(ngModel)]="initial.overrideExcluded">
        <label class="form-check-label"
               [for]='"customSwitchFillAndOverride"'></label> {{'lang.requirementBookingAssignment.fillOverrideExcludedBookings' | translate}}
      </div>
    </ng-container>
  </div>
  <div modal-footer>
    <button class="btn btn-primary" (click)="ok()">{{'lang.globals.submit' | translate}}</button>
  </div>
</sb-modal-template>
